const trimMultiLine = (s: string) => s.replace(/\ {2,}/g, '').trim()

const additionalFields = {
  audience: {
    tip: "Tell our writers the audience to keep in mind for your content. Are you speaking to older, traditional business people or young? Tech-savvy moms?",
    placeholder: "The target audience for my content is prospective customers. For my business, this is a restaurant owner or manager at higher-end establishments. They tend to be 40 or older...."
  },
  voiceAndPersonality: {
    tip: `Who's the "author" or "voice" for your content? Should it be written in the voice of the CEO/owner? A helpful customer service person?`,
    placeholder: trimMultiLine(`
      My content should be written as if it were coming from a friendly, knowledgeable expert in my customer care department. They understand our products, our industry, but aren't overly pushy about our business, rather educational about the problems our prospects face.
    `)
  },
  contentExample: {
    tip: "Add a link to a piece of content you think is outstanding. This could be from your own business, a competitor, or an unrelated industry. Why do you think it is great? How should writers apply this to what they're writing for you?",
    placeholder: trimMultiLine(`
      https://waitbutwhy.com/2017/04/neuralink.html

      I love how the writer of this piece takes a complex technical topic and makes it seem accessible and entertaining — he uses lots of examples, and isn't afraid to be playful with language. I'd like to have Verblio writers use a similar tone.
    `)
  },
  otherInfo: {
    tip: "Communicate anything else our writers need to know when writing for your business or client. Anything specific to a single piece of content should be put in your topic description, so use this section for universal truths.",
    placeholder: trimMultiLine(`Please never link to my competitors xyz.com and abc.com, and don't use Wikipedia as a reference.

      My business is located in Chicago, IL, and we serve customers throughout Illinois, so please include some local references when applicable!
    `)
  }
}

export { additionalFields }
